module.exports = __webpack_public_path__ + "x1.no2.7a4920e3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/x1.no2.jpg
// module id = LeyQ
// module chunks = 0